<template>
  <div>
    <div class="col-md-12">
        <h3>Clientes da base</h3>
        <table id="relLog" ref='tabela' class="table display table-hover table-striped" style="width: 100%">
            <thead></thead>
            <tbody></tbody>
            <tfoot></tfoot>
        </table>
    </div>

    <component :is="comp" :data="compData" v-on:dismissModal="dismissModal" />
  </div>
</template>

<script>
import modalCostumers from "./ModalCostumers.vue";
import { formata_cpf_cnpj } from '../../validaCPFeCNPJ';

export default {
  components: { modalCostumers },
  props: {
    filter: {
      type: String,
      default: "",
    },
    upList: 0,
  },
  data() {
    return {
      dt: null,
      val: this.filter,
      comp: "",
      compData: "",
    };
  },
  watch: {
    upList: function () {
      this.createTable();
    },
    filter: {
      handler: function (val) {
        this.createTable();
      },
      deep: true,
    },
  },
  methods: {
    dismissModal() {
      this.comp = "";
      this.createTable();
    },
    createTable() {
      if (this.dt) {
        $("#relLog").DataTable().destroy();
      }

      this.dt = $("#relLog").DataTable({
        responsive: true,
        processing: true,
        destroy: true,
        serverSide: true,
        ajax: {
          type: "GET",
          url: "/customer_base/getclients",
        },
        columns: [
          { data: "name", title: "Nome" },
          {
            data: "phone1",
            className: "text-center",
            title: "Telefone 1",
            render: (data) => {
              if(data){
                return this.formTelefone(data);
              }
              return "N/A";
            }
          },
          {
            data: "phone2",
            className: "text-center",
            title: "Telefone 2",
            render: (data) => {
              if(data){
                return this.formTelefone(data);
              }
              return "N/A";
            }
          },
          {
            data: "mobile",
            className: "text-center",
            title: "Celular",
            render: (data) => {
              if(data){
                return this.formTelefone(data);
              }
              return "N/A";
            }
          },
          {
            data: "cpf_cnpj",
            className: "text-center",
            title: "ID/ CPF/ CNPJ",
            render: (data) =>{
              if(data){
                return formata_cpf_cnpj(data);
              }
              return "N/A";
            }
          },
          {
            data: "operator",
            className: "text-center",
            title: "E-mail Operador",
            render: (data) =>{
              if (data){
                return data;
              }
              return "N/A";
            }
          },
          {
            data: "consultor_phone",
            className: "text-center",
            title: "Telefone Consultor",
            render: (data) => {
              if(data){
                return this.formTelefone(data);
              }
              return "N/A";
            }
          },
          {
            class: "details-control find-data text-center",
            data: "id",
            title: "Detalhes",
            render: (data) =>
              `<button type='button' class='find-data invisible-button detail-button'><i class='find-data fa fa-search-plus'></i></button>`,
          },
        ],
        order: [[0, "asc"]],
      });
    },
    formTelefone(tel) {
			if( (tel.length == 10) || (tel.length == 11) ) {
				const v1 = tel.replace(/\D/g,"");
				const v2 = v1.replace(/^(\d{2})(\d)/g,"($1) $2");
				const v3 = v2.replace(/(\d)(\d{4})$/,"$1-$2");
				
				return v3;
			}
			tel=tel.replace(/\D/g,"");
			tel=tel.replace(/^(\d)/,"+$1");
			tel=tel.replace(/(.{3})(\d)/,"$1($2");
			tel=tel.replace(/(.{6})(\d)/,"$1)$2");
			if(tel.length == 12) {
				tel=tel.replace(/(.{1})$/,"-$1");
			}
			else if (tel.length == 13) {
				tel=tel.replace(/(.{2})$/,"-$1");
			}
			else if (tel.length == 14) {
				tel=tel.replace(/(.{3})$/,"-$1");
			}
			else if (tel.length == 15) {
				tel=tel.replace(/(.{4})$/,"-$1");
			}
			else if (tel.length > 15) {
				tel=tel.replace(/(.{4})$/,"-$1");
			}
			tel=tel.replace("("," (");
			tel=tel.replace(")",") ");

			return tel;
		}
  },
  mounted() {
    this.createTable();

    document.querySelector("#relLog tbody").addEventListener("click", (e) => {
      if (e.target.classList.contains("find-data")) {
        const tr = e.target.closest("tr");
        const row = this.dt.row(tr).data();
        this.compData = row;
        this.comp = "modal-costumers";
      }
    });
  },
};
</script>

<style>
.detail-button {
  font-size: 18px !important;
  color: #1c869a;
}

.detail-button:hover {
  color: #0c4955;
  transition: 0.5s;
}
</style>